import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { Meta, Title } from '@angular/platform-browser';

@Component({
  selector: 'app-iscrizione-pagamento-annullato',
  standalone: true,
  templateUrl: './pagamento-annullato.component.html',
  styleUrl: './pagamento-annullato.component.scss',
  imports: [CommonModule, RouterLink],
})
export class IscrizionePagamentoAnnullatoComponent implements OnInit {
  private meta = inject(Meta);
  private title = inject(Title);

  ngOnInit() {
    this.title.setTitle('Pagamento Annullato - Come Tralci');

    this.meta.updateTag({
      name: 'robots',
      content: 'noindex, nofollow',
    });
  }
}
